import { ArrowUpRight } from "lucide-react";

const HERO_BG =
  "https://images.unsplash.com/photo-1695918808943-9db9cddc1ab3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBza3lsaW5lJTIwdHdpbGlnaHR8ZW58MHx8fHwxNzc2ODI0MDE3fDA&ixlib=rb-4.1.0&q=85";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] w-full overflow-hidden bg-[#050914]"
    >
      <div
        className="absolute inset-0 hero-zoom"
        style={{
          backgroundImage: `url(${HERO_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050914]/95 via-[#050914]/70 to-[#050914]/40" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050914]/40 via-transparent to-[#050914]" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 pt-40 md:pt-48 pb-24 md:pb-32 min-h-[100vh] flex flex-col justify-center">
        <div className="max-w-3xl">
          <p
            data-testid="hero-overline"
            className="text-[11px] md:text-xs font-bold uppercase tracking-[0.32em] text-[#d4af37] mb-8 reveal in"
          >
            <span className="gold-rule" /> Premier Consulting, Gov Con &amp; Logistics Group
          </p>

          <h1
            data-testid="hero-headline"
            className="font-serif-editorial text-[52px] leading-[1] md:text-[80px] md:leading-[0.95] lg:text-[104px] lg:leading-[0.92] font-light text-white reveal in"
            style={{ letterSpacing: "-0.025em" }}
          >
            Commanding
            <br />
            <span className="italic font-normal text-[#d4af37]">excellence</span> across
            <br />
            every contract.
          </h1>

          <p
            data-testid="hero-subtext"
            className="mt-8 md:mt-10 max-w-xl text-base md:text-lg text-slate-300/90 leading-relaxed font-light reveal"
          >
            A minority-owned enterprise operating two authoritative divisions —
            <span className="text-white"> Consulting &amp; Advisory</span> for federal
            and enterprise clients, and a fully-authorized
            <span className="text-white"> Logistics &amp; Transportation</span> carrier
            moving freight across the continental United States.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4 reveal">
            <a
              href="#services"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center justify-center gap-3 bg-[#d4af37] hover:bg-[#f1d570] text-[#050914] px-8 py-5 text-[12px] font-bold uppercase tracking-[0.28em] transition-colors"
            >
              Explore Services
              <ArrowUpRight
                size={16}
                className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </a>
            <a
              href="#contact"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center justify-center gap-3 border border-white/25 hover:border-[#d4af37] hover:text-[#d4af37] text-white px-8 py-5 text-[12px] font-bold uppercase tracking-[0.28em] transition-colors"
            >
              Engage the Firm
            </a>
          </div>
        </div>

        {/* Stat strip */}
        <div className="mt-20 md:mt-28 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10 max-w-4xl reveal">
          {[
            { k: "6", v: "National Offices" },
            { k: "40+", v: "Federal Engagements" },
            { k: "'18", v: "Top 40 Under 40" },
            { k: "100%", v: "Minority-Owned" },
          ].map((s) => (
            <div
              key={s.v}
              className="bg-[#050914]/90 p-6 md:p-8"
              data-testid={`hero-stat-${s.v.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="font-serif-editorial text-4xl md:text-5xl text-[#d4af37] leading-none">
                {s.k}
              </div>
              <div className="mt-3 text-[10px] md:text-[11px] uppercase tracking-[0.22em] text-slate-400">
                {s.v}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-slate-400">
        Scroll
        <span className="w-px h-10 bg-gradient-to-b from-[#d4af37] to-transparent" />
      </div>
    </section>
  );
};

export default Hero;
